/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .system-setting-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;

    .button-item {
      min-width: 12rem;
      max-width: 17rem;
    }
  }

  .doc-template-file {
    gap: 8px;

    .file-input {
      width: auto;
    }

    label {
      margin: 0;
    }
  }

  .doc-template-annotation {
    border: 1px solid transparent;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    overflow: hidden;
    width: 100%;

    &:last-of-type {
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
    }

    &.selected {
      border-color: ${$.primaryMain};
    }

    &:hover,
    &.selected {
      background-color: ${$.gray100};
    }
  }
`;
